import { generateLocalizedRouteConfig, LocalizedRoutes } from '@/router/localizedRouting';
import { RESULT_PATH } from '@/router/routes/constants';
import { Pages } from '@/types';

const Component = () => import('../../components/property-valuation-page/ResultPage');

const routes: LocalizedRoutes = {
  de: { path: RESULT_PATH['de'] },
  en: { path: RESULT_PATH['en'] },
  fr: { path: RESULT_PATH['fr'] },
  it: { path: RESULT_PATH['it'] },
};

const localizedRouteConfig = generateLocalizedRouteConfig(routes, Component, Pages.Result);

export default localizedRouteConfig;
